const PAGE_SIZE = 10;

export { PAGE_SIZE };
